import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { FAQS } from '../../data/welding';
export function FaqSection() {
  const [open, setOpen] = useState<number | null>(null);
  return <section id="faq" className="bg-mist py-14 text-ink sm:py-20" aria-labelledby="faq-title" data-id="element-165" data-mp="zryod3tacksf">
      <div className="mx-auto grid w-full max-w-6xl grid-cols-1 gap-6 px-5 sm:px-8 lg:grid-cols-12 lg:gap-14" data-id="element-166" data-mp="urko47xxef4y">
        <div className="lg:col-span-4" data-id="element-167" data-mp="731ik069gggk">
          <h2 id="faq-title" className="font-heading text-[2.05rem] font-bold uppercase leading-[0.98] text-ink sm:text-[2.8rem]" data-id="element-168" data-mp="22x2gb99lnqv">
            QUESTIONS BEFORE YOU START?
          </h2>
        </div>

        <ul className="divide-y divide-ink/10 border-y border-ink/10 lg:col-span-8" data-id="element-169" data-mp="bz01h88tl69l">
          {FAQS.map((faq, index) => {
          const isOpen = open === index;
          return <li key={faq.question} data-id="element-170" data-mp="1neyflqiuuiho" data-mpi={index}>
                <h3 data-id="element-171" data-mp="htpqci307slm">
                  <button type="button" id={`faq-trigger-${index}`} onClick={() => setOpen(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`faq-panel-${index}`} className="flex min-h-[64px] w-full items-center justify-between gap-4 py-4 text-left focus:outline-none focus-visible:ring-4 focus-visible:ring-arc/40" data-id="element-172" data-mp="hu8y55yxx0lx">
                    <span className="text-[1.02rem] font-semibold leading-snug text-ink sm:text-[1.08rem]" data-id="element-173" data-mp="3v6st63pfgzma">
                      {faq.question}
                    </span>
                    <span className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-full border transition-colors duration-150 ease-out ${isOpen ? 'border-arc bg-arc text-white' : 'border-ink/20 text-ink'}`} aria-hidden data-id="element-174" data-mp="82cu7ea6ag9s">
                      <PlusIcon className={`h-4 w-4 transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} data-id="element-175" data-mp="nozfx6fqq4wk" />
                    </span>
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-176" data-mp="xeiz6d7d80ry">
                  {isOpen && <motion.div id={`faq-panel-${index}`} role="region" aria-labelledby={`faq-trigger-${index}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-177" data-mp="sh0q8mtclljy">
                      <p className="max-w-2xl pb-5 pr-12 text-[0.98rem] leading-relaxed text-graphite" data-id="element-178" data-mp="1p4x4vm5866sj">{faq.answer}</p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}